// extracted by mini-css-extract-plugin
export var exit = "_3-3";
export var notificationContainer = "_3-1";
export var notificationStack = "_3-0";
export var shrinkFadeOut = "_3-4";
export var slideInUp = "_3-2";